import React from 'react';
import { FiTarget, FiUsers, FiClock, FiAward } from 'react-icons/fi';
import './TabNavigation.css';

const TABS = [
  { id: 'missions', label: 'ภารกิจ', Icon: FiTarget },
  { id: 'team', label: 'ทีม', Icon: FiUsers },
  { id: 'history', label: 'ประวัติ', Icon: FiClock },
  { id: 'ranking', label: 'อันดับ', Icon: FiAward },
];

const TabNavigation = ({ activeTab, onTabChange }) => {
  return (
    <div className="bts-tabs">
      <div className="bts-tabs__track">
        {TABS.map(({ id, label, Icon }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              className={`bts-tabs__btn${isActive ? ' bts-tabs__btn--active' : ''}`}
            >
              <Icon size={15} strokeWidth={isActive ? 3 : 2} />
              <span>{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNavigation;
